import { useEffect } from 'react'

export function useDisableUserSelect(condition: any) {
  useEffect(() => {
    if (condition) {
      document.documentElement.style.userSelect = 'none'
      document.documentElement.style.webkitUserSelect = 'none'

      return () => {
        document.documentElement.style.userSelect = ''
        document.documentElement.style.webkitUserSelect = ''
      }
    }
  }, [condition])
}
